import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { getUrlRequestPrefix } from 'helpers/Users';

/* Create Router Link component to request list or request entry if request id presents.
  Also add prefix for staff users (`/admin`).
  
  Examples:
    --- `/requests` (link to request list page for vendors)
    --- `/admin/requests` (link to request list page for staff users)
    --- `/requests/123` (vendor link to request page, request id=123)
    --- `/admin/requests/123` (staff link to request page, request id=123)
*/
class RequestsLink extends Component {
  render() {
    const { user, requestId, linkTitle = 'link' } = this.props;
    const prefix = getUrlRequestPrefix(user);
    const postfix = requestId ? `/${requestId}` : '';

    return <Link to={`${prefix}/requests${postfix}`}>{linkTitle}</Link>;
  }
}

function mapStateToProps({ user }) {
  return { user };
}

export default connect(mapStateToProps)(RequestsLink);



// WEBPACK FOOTER //
// ./src/components/RequestsLink.js